(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tgc-luxury-system"] && !Shopify.designMode) return;
  try {
    function initialiseTgcLuxury() {
    document.documentElement.classList.add('tgc-motion-ready');

    const header = document.querySelector('.shopify-section-group-header-group');
    const updateHeader = function () {
      if (!header) return;
      header.classList.toggle('tgc-header-scrolled', window.scrollY > 18);
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const targets = document.querySelectorAll(
      '.goldsmith-tile, .collection-list .grid__item, .image-with-text, .find-us-container, .tgc-about-card, .tgc-team-card, .tgc-contact-card, .tgc-engraving-card, .tgc-repair-card, .tgc-postal-card'
    );

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (target) { target.classList.add('tgc-visible'); });
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('tgc-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (target, index) {
      target.classList.add('tgc-reveal');
      target.style.transitionDelay = Math.min(index % 4, 3) * 70 + 'ms';
      observer.observe(target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseTgcLuxury, { once: true });
  } else {
    initialiseTgcLuxury();
  }

  document.addEventListener('shopify:section:load', initialiseTgcLuxury);
  } catch(e) { console.error(e); }
})();

})();
